/* ============================================================
   Project Briefcase — Polished UI
   ============================================================ */

// --------------- SVG Icons ---------------

const ICONS = {
  briefcase: '<svg class="briefcase-empty__icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>',
  check: '<svg class="briefcase-toast__icon" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3.5 8.5L6.5 11.5L12.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
  error: '<svg class="briefcase-toast__icon" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5"/><path d="M8 5v3M8 10v1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
  remove: '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
  plus: '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
  edit: '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M11.5 2.5l2 2L5 13H3v-2L11.5 2.5z" stroke="currentColor" stroke-width="1.2"/></svg>',
  trash: '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 4h10M6 4V3h4v1M5 4v9h6V4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  duplicate: '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="5" y="5" width="8" height="8" rx="1" stroke="currentColor" stroke-width="1.2"/><path d="M3 11V3h8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  datasheet: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0076ce" stroke-linecap="round" stroke-linejoin="round"><path d="M14.22,2v4.44c0,.61.5,1.11,1.11,1.11h4.44"/><path d="M17.56,22H6.44c-1.23,0-2.22-.99-2.22-2.22V4.22c0-1.23.99-2.22,2.22-2.22h7.78l5.56,5.56v12.22c0,1.23-.99,2.22-2.22,2.22Z"/><path d="M8.67,17.56h6.67"/><path d="M8.67,13.11h6.67"/><path d="M8.67,8.67h3.33"/></svg>',
  photometry: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0076ce" stroke-linecap="round" stroke-linejoin="round"><path d="M14.22,2v4.44c0,.61.5,1.11,1.11,1.11h4.44"/><path d="M17.56,22H6.44c-1.23,0-2.22-.99-2.22-2.22V4.22c0-1.23.99-2.22,2.22-2.22h7.78l5.56,5.56v12.22c0,1.23-.99,2.22-2.22,2.22Z"/><path d="M10.29,15.42c-1.26-.95-1.52-2.74-.57-4,.95-1.26,2.74-1.52,4-.57,1.26.95,1.52,2.74.57,4-.16.22-.35.41-.57.57-.45.45-.66,1.08-.57,1.71,0,.63-.51,1.14-1.14,1.14s-1.14-.51-1.14-1.14c.09-.63-.12-1.27-.57-1.71M10.69,15.99h2.63"/></svg>'
};

// --------------- API Client ---------------

class BriefcaseAPI {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  async request(path, method = 'GET', body = null) {
    const url = `${this.baseUrl}${path}`;
    const options = {
      method,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    };
    if (body) options.body = JSON.stringify(body);

    const response = await fetch(url, options);
    if (!response.ok) {
      const text = await response.text();
      const err = new Error(text || response.statusText);
      err.status = response.status;
      throw err;
    }
    return response.json();
  }

  getProjects() { return this.request('/projects'); }
  createProject(name) { return this.request('/projects', 'POST', { name }); }
  updateProject(handle, fields) { return this.request(`/projects/${handle}`, 'PUT', fields); }
  deleteProject(handle) { return this.request(`/projects/${handle}`, 'DELETE'); }
  duplicateProject(handle) { return this.request(`/projects/${handle}/duplicate`, 'POST'); }
  getItems(handle) { return this.request(`/projects/${handle}/items`); }
  addItem(handle, product) { return this.request(`/projects/${handle}/items`, 'POST', product); }
  removeItem(handle, itemId) { return this.request(`/projects/${handle}/items/${itemId}`, 'DELETE'); }
  setLabel(handle, itemId, label) { return this.request(`/projects/${handle}/items/${itemId}/label`, 'PUT', { label }); }
  setNotes(handle, itemId, notes) { return this.request(`/projects/${handle}/items/${itemId}/notes`, 'PUT', { notes }); }
  duplicateItem(handle, itemId) { return this.request(`/projects/${handle}/items/${itemId}/duplicate`, 'POST'); }
}

const briefcaseApi = new BriefcaseAPI(theme.briefcaseUrl);

// --------------- Local Cache ---------------

const BriefcaseCache = {
  KEY: 'Concept:briefcase',
  get() { try { return JSON.parse(localStorage.getItem(this.KEY)) || null; } catch { return null; } },
  set(data) { try { localStorage.setItem(this.KEY, JSON.stringify(data)); } catch {} },
  clear() { try { localStorage.removeItem(this.KEY); } catch {} }
};

// --------------- PubSub ---------------

const BRIEFCASE_UPDATE = 'briefcaseUpdate';
if (theme.pubsub && !theme.pubsub.PUB_SUB_EVENTS.briefcaseUpdate) {
  theme.pubsub.PUB_SUB_EVENTS.briefcaseUpdate = BRIEFCASE_UPDATE;
}

// --------------- Toast ---------------

function showBriefcaseToast(message, type = 'success') {
  const toast = document.querySelector('[data-briefcase-toast]');
  if (!toast) return;

  const icon = type === 'success' ? ICONS.check : type === 'error' ? ICONS.error : '';
  toast.className = `briefcase-toast briefcase-toast--${type}`;
  toast.innerHTML = `${icon}<span>${escapeHtml(message)}</span>`;
  toast.setAttribute('active', '');

  clearTimeout(toast._timeout);
  toast._timeout = setTimeout(() => toast.removeAttribute('active'), 3000);
}

function openBriefcaseDrawer() {
  const drawer = document.querySelector('briefcase-drawer');
  if (!drawer) return;
  if (typeof drawer.show === 'function') drawer.show();
  else drawer.removeAttribute('hidden');
}

function showBriefcaseSuccessNotification({ product, projectName, variant = 'success' }) {
  const el = document.querySelector('[data-briefcase-success]');
  if (!el) return;

  const strings = (window.theme && theme.briefcaseStrings) || {};
  const headingTemplate = variant === 'info'
    ? (strings.alreadyInProject || 'Already in __PROJECT__')
    : (strings.addedToProject || 'Added to __PROJECT__');
  const ctaLabel = strings.viewBriefcase || 'View Briefcase';
  const closeLabel = strings.close || 'Close';
  const [headingBefore, headingAfter] = headingTemplate.split('__PROJECT__');

  const imgSrc = product?.imageUrl || '';
  const imgMarkup = imgSrc
    ? `<img src="${escapeHtml(imgSrc)}" alt="" loading="lazy" width="56" height="56">`
    : '';

  const badgeMarkup = variant === 'info'
    ? '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="6.5"/><path d="M8 5.5v3.5M8 11v.5"/></svg>'
    : '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 8.5L6.5 11.5L12.5 4.5"/></svg>';

  const DURATION_MS = 5000;
  el.style.setProperty('--briefcase-toast-duration', `${DURATION_MS}ms`);
  el.hidden = false;
  el.dataset.variant = variant;
  el.innerHTML = `
    <button class="briefcase-success-toast__close" type="button" aria-label="${escapeHtml(closeLabel)}" data-briefcase-success-close>&times;</button>
    <div class="briefcase-success-toast__media">
      ${imgMarkup}
      <span class="briefcase-success-toast__check" aria-hidden="true">
        ${badgeMarkup}
      </span>
    </div>
    <div class="briefcase-success-toast__content">
      <p class="briefcase-success-toast__heading">
        <span>${escapeHtml(headingBefore || '')}</span>
        <span class="briefcase-success-toast__project">${escapeHtml(projectName || '')}</span>
        <span>${escapeHtml(headingAfter || '')}</span>
      </p>
      ${product?.title ? `<p class="briefcase-success-toast__product">${escapeHtml(product.title)}</p>` : ''}
    </div>
    <button class="briefcase-success-toast__cta" type="button" data-briefcase-success-cta>${escapeHtml(ctaLabel)}</button>
    <span class="briefcase-success-toast__progress" aria-hidden="true"></span>
  `;

  // Force a reflow so the progress animation restarts cleanly when reused
  void el.offsetWidth;
  el.setAttribute('active', '');

  const dismiss = () => {
    el.removeAttribute('active');
    el.removeAttribute('data-paused');
    clearTimeout(el._dismissTimer);
    el._dismissTimer = null;
    setTimeout(() => { if (!el.hasAttribute('active')) el.hidden = true; }, 320);
  };

  clearTimeout(el._dismissTimer);
  el._dismissTimer = setTimeout(dismiss, DURATION_MS);

  // Pause auto-dismiss while user hovers / focuses
  el.onmouseenter = () => {
    if (!el._dismissTimer) return;
    clearTimeout(el._dismissTimer);
    el._dismissTimer = null;
    el.setAttribute('data-paused', '');
  };
  el.onmouseleave = () => {
    el.removeAttribute('data-paused');
    el._dismissTimer = setTimeout(dismiss, 1500);
  };

  el.querySelector('[data-briefcase-success-close]')?.addEventListener('click', dismiss, { once: true });
  el.querySelector('[data-briefcase-success-cta]')?.addEventListener('click', () => {
    dismiss();
    openBriefcaseDrawer();
  }, { once: true });
}

// --------------- Helpers ---------------

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str || '';
  return div.innerHTML;
}

// --------------- Drawer Element ---------------

if (!customElements.get('briefcase-drawer')) {
  customElements.define(
    'briefcase-drawer',
    class BriefcaseDrawer extends DrawerElement {
      constructor() {
        super();
        this.projects = [];
        this.currentHandle = null;
        this.items = [];
        this.labelFilter = null;
      }

      get shouldAppendToBody() { return false; }
      get container() { return this.querySelector('[data-briefcase-container]'); }
      get footer() { return this.querySelector('[data-briefcase-footer]'); }
      get footerContent() { return this.querySelector('[data-briefcase-footer-content]'); }

      connectedCallback() {
        super.connectedCallback();
        theme.pubsub.subscribe(BRIEFCASE_UPDATE, () => this.refresh());
      }

      async beforeShow() {
        super.beforeShow();
        await this.loadProjects();
      }

      async loadProjects() {
        if (!theme.customer) { this.renderLoginPrompt(); return; }
        this.renderLoading();

        try {
          const data = await briefcaseApi.getProjects();
          this.projects = data.projects || [];
          BriefcaseCache.set({ projects: this.projects });
          this.renderContent();
        } catch (err) {
          console.error('Briefcase: Failed to load projects', err);
          this.renderError();
        }
      }

      async loadItems(handle) {
        this.currentHandle = handle;
        this.labelFilter = null;

        try {
          const data = await briefcaseApi.getItems(handle);
          this.items = data.items || [];
          this.renderItemsArea();
          this.renderFooter();
        } catch (err) {
          console.error('Briefcase: Failed to load items', err);
          this.items = [];
          this.renderItemsArea();
          this.renderFooter();
        }
      }

      async refresh() {
        if (this.hasAttribute('open')) {
          BriefcaseCache.clear();
          await this.loadProjects();
        }
      }

      // ---- Main render ----

      renderContent() {
        if (this.projects.length === 0) {
          this.renderEmptyNoProjects();
          return;
        }
        this.currentHandle = this.currentHandle || this.projects[0].handle;
        // Make sure currentHandle still exists
        if (!this.projects.find(p => p.handle === this.currentHandle)) {
          this.currentHandle = this.projects[0].handle;
        }
        this.container.innerHTML = '<div data-briefcase-selector></div><div data-briefcase-items-area></div>';
        this.renderProjectSelector();
        this.loadItems(this.currentHandle);
      }

      // ---- Loading ----

      renderLoading() {
        this.container.innerHTML = `
          <div class="briefcase-skeleton">
            ${Array(4).fill(`
              <div class="briefcase-skeleton__row">
                <div class="briefcase-skeleton__box briefcase-skeleton__box--media briefcase-skeleton__shimmer" style="width:var(--sp-20);height:var(--sp-20);flex-shrink:0"></div>
                <div class="briefcase-skeleton__details">
                  <div class="briefcase-skeleton__box briefcase-skeleton__shimmer" style="height:var(--sp-3);width:80%"></div>
                  <div class="briefcase-skeleton__box briefcase-skeleton__shimmer" style="height:var(--sp-3);width:50%"></div>
                  <div class="briefcase-skeleton__box briefcase-skeleton__shimmer" style="height:var(--sp-2);width:30%"></div>
                </div>
              </div>
            `).join('')}
          </div>
        `;
        this.footer.hidden = true;
      }

      // ---- Login ----

      renderLoginPrompt() {
        const s = theme.briefcaseStrings;
        this.container.innerHTML = `
          <div class="briefcase-login">
            ${ICONS.briefcase}
            <div class="briefcase-empty__title">${s.title}</div>
            <div class="briefcase-login__message">${s.loginRequired}</div>
            <a href="${theme.storefrontLoginUrl}" class="briefcase-login__btn">${s.loginButton}</a>
          </div>
        `;
        this.footer.hidden = true;
      }

      // ---- Empty (no projects) ----

      renderEmptyNoProjects() {
        const s = theme.briefcaseStrings;
        this.container.innerHTML = `
          <div class="briefcase-empty">
            ${ICONS.briefcase}
            <div class="briefcase-empty__title">${s.empty}</div>
            <div class="briefcase-empty__message">${s.emptyMessage}${s.emptyMessage2 ? '<br><br>' + s.emptyMessage2 : ''}</div>
            <button class="briefcase-modal__btn briefcase-modal__btn--primary" data-action="new-project">${ICONS.plus} ${s.newProject}</button>
          </div>
        `;
        this.container.querySelector('[data-action="new-project"]')?.addEventListener('click', () => this.showInlineModal('new'));
        this.footer.hidden = true;
      }

      // ---- Error ----

      renderError() {
        this.container.innerHTML = `
          <div class="briefcase-empty">
            ${ICONS.error}
            <div class="briefcase-empty__title">Error</div>
            <div class="briefcase-empty__message">Could not load briefcase data. Please try again.</div>
          </div>
        `;
        this.footer.hidden = true;
      }

      // ---- Project Selector ----

      renderProjectSelector() {
        const s = theme.briefcaseStrings;
        const el = this.container.querySelector('[data-briefcase-selector]');
        if (!el) return;

        const project = this.projects.find(p => p.handle === this.currentHandle);

        // Build compact summary for project details toggle
        const detailParts = [];
        if (project?.architect) detailParts.push(escapeHtml(project.architect));
        if (project?.projectNotes) detailParts.push(escapeHtml(project.projectNotes.length > 40 ? project.projectNotes.substring(0, 40) + '...' : project.projectNotes));
        const detailSummary = detailParts.length > 0 ? detailParts.join(' · ') : 'Enter some project details';
        const detailMuted = detailParts.length === 0;

        el.innerHTML = `
          <div class="briefcase-project-selector">
            <select data-briefcase-project-select>
              ${this.projects.map(p =>
                `<option value="${p.handle}" ${p.handle === this.currentHandle ? 'selected' : ''}>${escapeHtml(p.name)}${p.itemCount ? ` (${p.itemCount})` : ''}</option>`
              ).join('')}
            </select>
            <div class="briefcase-project-actions">
              <button type="button" data-action="new-project" title="${s.newProject}" aria-label="${s.newProject}">${ICONS.plus}</button>
              <button type="button" data-action="rename" title="${s.rename}" aria-label="${s.rename}">${ICONS.edit}</button>
              <button type="button" data-action="duplicate" title="${s.duplicate || 'Duplicate'}" aria-label="${s.duplicate || 'Duplicate project'}">${ICONS.duplicate}</button>
              <button type="button" data-action="delete" data-briefcase-delete title="${s.deleteProject}" aria-label="${s.deleteProject}">${ICONS.trash}</button>
            </div>
          </div>
          <button type="button" class="briefcase-details-toggle" data-briefcase-details-toggle aria-expanded="false">
            <svg class="briefcase-details-toggle__chevron" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3 4l2 2 2-2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>
            <span class="${detailMuted ? 'briefcase-details-toggle__summary--muted' : ''}">${detailSummary}</span>
          </button>
          <div class="briefcase-project-fields" data-briefcase-details-panel hidden>
            <div class="briefcase-project-field">
              <label class="briefcase-project-field__label">${s.architect || 'Architect / Designer'}</label>
              <input type="text" class="briefcase-project-field__input" data-briefcase-architect value="${escapeHtml(project?.architect || '')}" placeholder="${s.architectPlaceholder || 'Enter architect or designer...'}">
            </div>
            <div class="briefcase-project-field">
              <label class="briefcase-project-field__label">${s.projectNotes || 'Project Notes'}</label>
              <textarea class="briefcase-project-field__input briefcase-project-field__textarea" data-briefcase-project-notes rows="2" placeholder="${s.projectNotesPlaceholder || 'Internal notes (not shown on datasheet)...'}">${escapeHtml(project?.projectNotes || '')}</textarea>
            </div>
          </div>
          <div data-briefcase-modal-slot></div>
        `;

        el.querySelector('[data-briefcase-project-select]')?.addEventListener('change', (e) => this.loadItems(e.target.value));
        el.querySelector('[data-action="new-project"]')?.addEventListener('click', () => this.showInlineModal('new'));
        el.querySelector('[data-action="rename"]')?.addEventListener('click', () => this.showInlineModal('rename'));
        el.querySelector('[data-action="delete"]')?.addEventListener('click', () => this.showInlineModal('delete'));

        // Toggle project details panel
        const detailsToggle = el.querySelector('[data-briefcase-details-toggle]');
        const detailsPanel = el.querySelector('[data-briefcase-details-panel]');
        detailsToggle?.addEventListener('click', () => {
          const expanded = detailsToggle.getAttribute('aria-expanded') === 'true';
          detailsToggle.setAttribute('aria-expanded', String(!expanded));
          detailsPanel.hidden = expanded;
          if (!expanded) {
            const firstInput = detailsPanel.querySelector('input, textarea');
            setTimeout(() => firstInput?.focus(), 50);
          }
        });

        // Duplicate project
        el.querySelector('[data-action="duplicate"]')?.addEventListener('click', async () => {
          const btn = el.querySelector('[data-action="duplicate"]');
          btn.disabled = true;
          try {
            const data = await briefcaseApi.duplicateProject(this.currentHandle);
            this.projects.push({ id: data.id, handle: data.handle, name: data.name, architect: project?.architect || '', projectNotes: project?.projectNotes || '', itemCount: this.items.length, createdAt: new Date().toISOString() });
            this.currentHandle = data.handle;
            BriefcaseCache.set({ projects: this.projects });
            this.renderContent();
            showBriefcaseToast(`Duplicated → "${data.name}"`);
          } catch (err) {
            console.error('Briefcase: Failed to duplicate', err);
            showBriefcaseToast('Failed to duplicate project', 'error');
            btn.disabled = false;
          }
        });

        // Project-level fields: auto-save on blur + update toggle summary
        const architectInput = el.querySelector('[data-briefcase-architect]');
        const projectNotesInput = el.querySelector('[data-briefcase-project-notes]');

        const updateToggleSummary = () => {
          const toggle = el.querySelector('[data-briefcase-details-toggle]');
          if (!toggle) return;
          const parts = [];
          const arch = architectInput?.value?.trim();
          const notes = projectNotesInput?.value?.trim();
          if (arch) parts.push(escapeHtml(arch));
          if (notes) parts.push(escapeHtml(notes.length > 40 ? notes.substring(0, 40) + '...' : notes));
          const span = toggle.querySelector('span');
          if (span) {
            span.textContent = parts.length > 0 ? parts.join(' · ') : 'Enter some project details';
            span.className = parts.length > 0 ? '' : 'briefcase-details-toggle__summary--muted';
          }
        };

        architectInput?.addEventListener('blur', async () => {
          const val = architectInput.value.trim();
          updateToggleSummary();
          if (project && val !== (project.architect || '')) {
            project.architect = val;
            BriefcaseCache.set({ projects: this.projects });
            try { await briefcaseApi.updateProject(this.currentHandle, { architect: val }); }
            catch (err) { console.error('Briefcase: Failed to save architect', err); }
          }
        });

        projectNotesInput?.addEventListener('blur', async () => {
          const val = projectNotesInput.value.trim();
          updateToggleSummary();
          if (project && val !== (project.projectNotes || '')) {
            project.projectNotes = val;
            BriefcaseCache.set({ projects: this.projects });
            try { await briefcaseApi.updateProject(this.currentHandle, { project_notes: val }); }
            catch (err) { console.error('Briefcase: Failed to save project notes', err); }
          }
        });
      }

      // ---- Inline Modal (replaces browser prompt/confirm) ----

      showInlineModal(type) {
        const s = theme.briefcaseStrings;
        const existingModal = this.container.querySelector('.briefcase-modal');

        // Toggle: if same modal type is already open, close it
        if (existingModal && existingModal.dataset.modalType === type) {
          existingModal.remove();
          return;
        }

        const slot = this.container.querySelector('[data-briefcase-modal-slot]');
        if (!slot) {
          if (existingModal) existingModal.remove();
          this.container.insertAdjacentHTML('beforeend', this.getModalHTML(type, s));
          this.bindModalEvents(this.container.querySelector('.briefcase-modal'), type);
          return;
        }

        slot.innerHTML = this.getModalHTML(type, s);
        this.bindModalEvents(slot.querySelector('.briefcase-modal'), type);
      }

      getModalHTML(type, s) {
        const project = this.projects.find(p => p.handle === this.currentHandle);

        if (type === 'new') {
          return `
            <div class="briefcase-modal" data-modal-type="${type}">
              <div class="briefcase-modal__title">${s.newProject}</div>
              <input class="briefcase-modal__input" type="text" placeholder="${s.projectNamePlaceholder}" data-modal-input autofocus>
              <div class="briefcase-modal__actions">
                <button class="briefcase-modal__btn" data-modal-cancel>Cancel</button>
                <button class="briefcase-modal__btn briefcase-modal__btn--primary" data-modal-confirm>${s.createProject}</button>
              </div>
            </div>
          `;
        }
        if (type === 'rename') {
          return `
            <div class="briefcase-modal" data-modal-type="${type}">
              <div class="briefcase-modal__title">${s.rename}</div>
              <input class="briefcase-modal__input" type="text" value="${escapeHtml(project?.name || '')}" data-modal-input autofocus>
              <div class="briefcase-modal__actions">
                <button class="briefcase-modal__btn" data-modal-cancel>Cancel</button>
                <button class="briefcase-modal__btn briefcase-modal__btn--primary" data-modal-confirm>${s.rename}</button>
              </div>
            </div>
          `;
        }
        if (type === 'delete') {
          return `
            <div class="briefcase-modal" data-modal-type="${type}">
              <div class="briefcase-modal__message">${s.confirmDelete}<br><strong>${escapeHtml(project?.name || '')}</strong></div>
              <div class="briefcase-modal__actions">
                <button class="briefcase-modal__btn" data-modal-cancel>Cancel</button>
                <button class="briefcase-modal__btn briefcase-modal__btn--danger" data-modal-confirm>${s.deleteProject}</button>
              </div>
            </div>
          `;
        }
        if (type === 'label') {
          const item = this._labelTarget;
          return `
            <div class="briefcase-modal" data-modal-type="${type}">
              <div class="briefcase-modal__title">${s.setLabel}: ${escapeHtml(item?.title || '')}</div>
              <input class="briefcase-modal__input" type="text" value="${escapeHtml(item?.label || '')}" placeholder="${s.label}" data-modal-input autofocus>
              <div class="briefcase-modal__actions">
                <button class="briefcase-modal__btn" data-modal-cancel>Cancel</button>
                <button class="briefcase-modal__btn briefcase-modal__btn--primary" data-modal-confirm>${s.setLabel}</button>
              </div>
            </div>
          `;
        }
        if (type === 'notes') {
          const item = this._notesTarget;
          return `
            <div class="briefcase-modal" data-modal-type="${type}">
              <div class="briefcase-modal__title">${s.notes || 'Notes'}: ${escapeHtml(item?.title || '')}</div>
              <textarea class="briefcase-modal__textarea" rows="4" placeholder="${s.notesPlaceholder || 'Add notes for this product...'}" data-modal-input autofocus>${escapeHtml(item?.notes || '')}</textarea>
              <div class="briefcase-modal__actions">
                <button class="briefcase-modal__btn" data-modal-cancel>Cancel</button>
                <button class="briefcase-modal__btn briefcase-modal__btn--primary" data-modal-confirm>${s.saveNotes || 'Save'}</button>
              </div>
            </div>
          `;
        }
        return '';
      }

      bindModalEvents(modal, type) {
        if (!modal) return;
        const input = modal.querySelector('[data-modal-input]');
        const confirmBtn = modal.querySelector('[data-modal-confirm]');
        const cancelBtn = modal.querySelector('[data-modal-cancel]');

        // Auto-focus input
        setTimeout(() => input?.focus(), 50);

        // Enter key on input
        input?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') confirmBtn?.click();
          if (e.key === 'Escape') cancelBtn?.click();
        });

        cancelBtn?.addEventListener('click', () => {
          modal.remove();
        });

        confirmBtn?.addEventListener('click', async () => {
          confirmBtn.classList.add('briefcase-modal__btn--loading');
          confirmBtn.textContent = '...';

          try {
            if (type === 'new') {
              const name = input?.value?.trim();
              if (!name) { input?.focus(); confirmBtn.classList.remove('briefcase-modal__btn--loading'); confirmBtn.textContent = theme.briefcaseStrings.createProject; return; }
              const data = await briefcaseApi.createProject(name);
              // Optimistic: add to local state immediately (don't wait for API re-fetch)
              this.projects.push({ id: data.id, handle: data.handle, name, itemCount: 0, createdAt: new Date().toISOString() });
              this.currentHandle = data.handle;
              this.items = [];
              BriefcaseCache.set({ projects: this.projects });
              modal.remove();
              this.renderContent();
              showBriefcaseToast(`${theme.briefcaseStrings.createProject}: ${name}`);
            }
            if (type === 'rename') {
              const name = input?.value?.trim();
              const project = this.projects.find(p => p.handle === this.currentHandle);
              if (!name || name === project?.name) { modal.remove(); return; }
              await briefcaseApi.updateProject(this.currentHandle, { name });
              // Optimistic: update local state
              if (project) project.name = name;
              BriefcaseCache.set({ projects: this.projects });
              modal.remove();
              this.renderProjectSelector();
              showBriefcaseToast(`Renamed to "${name}"`);
            }
            if (type === 'delete') {
              await briefcaseApi.deleteProject(this.currentHandle);
              // Optimistic: remove from local state
              this.projects = this.projects.filter(p => p.handle !== this.currentHandle);
              this.currentHandle = null;
              BriefcaseCache.set({ projects: this.projects });
              modal.remove();
              this.renderContent();
              showBriefcaseToast(theme.briefcaseStrings.deleteProject);
            }
            if (type === 'label') {
              const item = this._labelTarget;
              const label = input?.value?.trim() || '';
              await briefcaseApi.setLabel(this.currentHandle, item.id, label);
              item.label = label;
              modal.remove();
              this.renderItemsArea();
            }
            if (type === 'notes') {
              const item = this._notesTarget;
              const notes = input?.value?.trim() || '';
              await briefcaseApi.setNotes(this.currentHandle, item.id, notes);
              item.notes = notes;
              modal.remove();
              this.renderItemsArea();
            }
          } catch (err) {
            console.error('Briefcase action failed:', err);
            showBriefcaseToast('Action failed. Please try again.', 'error');
            confirmBtn.classList.remove('briefcase-modal__btn--loading');
          }
        });
      }

      // ---- Items Area ----

      renderItemsArea() {
        const s = theme.briefcaseStrings;
        const area = this.container.querySelector('[data-briefcase-items-area]');
        if (!area) return;

        let filtered = this.items;
        if (this.labelFilter) {
          filtered = this.items.filter(item => item.label === this.labelFilter);
        }

        // Label filter bar
        const uniqueLabels = [...new Set(this.items.map(i => i.label).filter(Boolean))];
        let filterHTML = '';
        if (uniqueLabels.length > 0) {
          filterHTML = `
            <div class="briefcase-filter">
              <button class="briefcase-filter-chip" aria-pressed="${!this.labelFilter}" data-briefcase-filter="">${s.allItems}</button>
              ${uniqueLabels.map(label =>
                `<button class="briefcase-filter-chip" aria-pressed="${this.labelFilter === label}" data-briefcase-filter="${escapeHtml(label)}">${escapeHtml(label)}</button>`
              ).join('')}
            </div>
          `;
        }

        // Items list
        let itemsHTML = '';
        if (this.items.length === 0) {
          itemsHTML = `
            <div class="briefcase-empty">
              ${ICONS.briefcase}
              <div class="briefcase-empty__message">${s.emptyMessage}${s.emptyMessage2 ? '<br><br>' + s.emptyMessage2 : ''}</div>
            </div>
          `;
        } else if (filtered.length === 0) {
          itemsHTML = `
            <div class="briefcase-empty">
              <div class="briefcase-empty__message">No items with this label.</div>
            </div>
          `;
        } else {
          const project = this.projects.find(p => p.handle === this.currentHandle);
          itemsHTML = `
            <ul class="briefcase-items">
              ${filtered.map(item => {
                // SKU line (own row) + Type Number / Set Type Number (own row)
                let skuLine = '';
                {
                  const skuHTML = item.sku
                    ? `<div class="briefcase-item__sku">${escapeHtml(item.sku)}</div>`
                    : '';
                  const typeHTML = item.label
                    ? `<div class="briefcase-item__type-line"><span class="briefcase-item__type" data-briefcase-edit-label="${item.id}">${escapeHtml(item.label)}</span></div>`
                    : `<div class="briefcase-item__type-line"><button class="briefcase-label__add" data-briefcase-edit-label="${item.id}">${s.setLabel}</button></div>`;
                  skuLine = `${skuHTML}${typeHTML}`;
                }

                // Notes line
                const notesLine = item.notes
                  ? `<div class="briefcase-item__notes" data-briefcase-edit-notes="${item.id}" title="${escapeHtml(item.notes)}">${escapeHtml(item.notes.length > 60 ? item.notes.substring(0, 60) + '...' : item.notes)}</div>`
                  : `<button class="briefcase-label__add" data-briefcase-edit-notes="${item.id}">${s.setNotes || 'Set Notes'}</button>`;

                // Datasheet dropdown
                let datasheetHTML = '';
                if (item.datasheetUrl) {
                  datasheetHTML = `
                    <div class="briefcase-datasheet-wrap">
                      <button type="button" class="briefcase-download-btn" data-briefcase-datasheet-trigger="${item.id}" title="Download Datasheet" aria-label="Download Datasheet: ${escapeHtml(item.title)}">${ICONS.datasheet}<span>Datasheet</span><svg class="briefcase-datasheet-chevron" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3 4l2 2 2-2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg></button>
                      <div class="briefcase-datasheet-menu" data-briefcase-datasheet-menu="${item.id}" hidden>
                        <button type="button" class="briefcase-datasheet-menu__item" data-briefcase-datasheet-plain="${item.id}">Without project info</button>
                        <button type="button" class="briefcase-datasheet-menu__item" data-briefcase-datasheet-project="${item.id}">With project info</button>
                      </div>
                    </div>
                  `;
                }

                return `
                <li class="briefcase-item" data-item-id="${item.id}">
                  <div class="briefcase-item__media">
                    <a href="${theme.routes.root_url}products/${item.handle}">
                      <img src="${item.imageUrl || ''}" alt="${escapeHtml(item.title)}" loading="lazy">
                    </a>
                  </div>
                  <div class="briefcase-item__details">
                    <div class="briefcase-item__title">
                      <a href="${theme.routes.root_url}products/${item.handle}">${escapeHtml(item.title)}</a>
                    </div>
                    ${skuLine}
                    ${notesLine}
                    <div class="briefcase-item__downloads">
                      ${datasheetHTML}
                      ${item.iesUrl ? `<a href="${item.iesUrl}" target="_blank" class="briefcase-download-btn" title="Download Photometry" aria-label="Download Photometry: ${escapeHtml(item.title)}">${ICONS.photometry}<span>IES</span></a>` : ''}
                    </div>
                  </div>
                  <div class="briefcase-item__actions">
                    <button class="briefcase-item__duplicate" data-briefcase-duplicate="${item.id}" title="${s.duplicateItem || 'Duplicate'}" aria-label="${s.duplicateItem || 'Duplicate'}: ${escapeHtml(item.title)}">
                      ${ICONS.duplicate}
                    </button>
                    <button class="briefcase-item__remove" data-briefcase-remove="${item.id}" title="${s.remove}" aria-label="${s.remove}: ${escapeHtml(item.title)}">
                      ${ICONS.remove}
                    </button>
                  </div>
                </li>
              `}).join('')}
            </ul>
          `;
        }

        area.innerHTML = filterHTML + itemsHTML;

        // Events: filter chips
        area.querySelectorAll('[data-briefcase-filter]').forEach(chip => {
          chip.addEventListener('click', () => {
            this.labelFilter = chip.dataset.briefcaseFilter || null;
            this.renderItemsArea();
          });
        });

        // Events: remove
        area.querySelectorAll('[data-briefcase-remove]').forEach(btn => {
          btn.addEventListener('click', () => this.removeItem(btn.dataset.briefcaseRemove));
        });

        // Events: duplicate (same product, new blank Type Number)
        area.querySelectorAll('[data-briefcase-duplicate]').forEach(btn => {
          btn.addEventListener('click', () => this.duplicateItem(btn.dataset.briefcaseDuplicate));
        });

        // Events: label (type number)
        area.querySelectorAll('[data-briefcase-edit-label]').forEach(el => {
          el.addEventListener('click', () => {
            const item = this.items.find(i => i.id === el.dataset.briefcaseEditLabel);
            if (!item) return;
            this._labelTarget = item;
            this.showInlineModal('label');
          });
        });

        // Events: notes
        area.querySelectorAll('[data-briefcase-edit-notes]').forEach(el => {
          el.addEventListener('click', () => {
            const item = this.items.find(i => i.id === el.dataset.briefcaseEditNotes);
            if (!item) return;
            this._notesTarget = item;
            this.showInlineModal('notes');
          });
        });

        // Events: datasheet dropdown
        area.querySelectorAll('[data-briefcase-datasheet-trigger]').forEach(btn => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const id = btn.dataset.briefcaseDatasheetTrigger;
            const menu = area.querySelector(`[data-briefcase-datasheet-menu="${id}"]`);
            if (!menu) return;
            // Close all other menus first
            area.querySelectorAll('[data-briefcase-datasheet-menu]:not([hidden])').forEach(m => {
              if (m !== menu) m.hidden = true;
            });
            menu.hidden = !menu.hidden;
          });
        });

        area.querySelectorAll('[data-briefcase-datasheet-plain]').forEach(btn => {
          btn.addEventListener('click', () => {
            const item = this.items.find(i => i.id === btn.dataset.briefcaseDatasheetPlain);
            if (item?.datasheetUrl) window.open(item.datasheetUrl, '_blank');
            const menu = btn.closest('[data-briefcase-datasheet-menu]');
            if (menu) menu.hidden = true;
          });
        });

        area.querySelectorAll('[data-briefcase-datasheet-project]').forEach(btn => {
          btn.addEventListener('click', () => {
            const item = this.items.find(i => i.id === btn.dataset.briefcaseDatasheetProject);
            if (!item?.datasheetUrl) return;
            const project = this.projects.find(p => p.handle === this.currentHandle);
            const params = new URLSearchParams();
            if (project?.name) params.set('project', project.name);
            if (project?.architect) params.set('architect', project.architect);
            if (item.label) params.set('type', item.label);
            if (item.notes) params.set('notes', item.notes);
            const sep = item.datasheetUrl.includes('?') ? '&' : '?';
            window.open(item.datasheetUrl + (params.toString() ? sep + params.toString() : ''), '_blank');
            const menu = btn.closest('[data-briefcase-datasheet-menu]');
            if (menu) menu.hidden = true;
          });
        });

        // Close datasheet menus on outside click
        const closeMenus = (e) => {
          if (!e.target.closest('.briefcase-datasheet-wrap') && !e.target.closest('[data-briefcase-datasheet-menu]')) {
            area.querySelectorAll('[data-briefcase-datasheet-menu]:not([hidden])').forEach(m => m.hidden = true);
          }
        };
        document.removeEventListener('click', this._closeDatasheetMenus);
        this._closeDatasheetMenus = closeMenus;
        document.addEventListener('click', closeMenus);
      }

      // ---- Footer ----

      renderFooter() {
        const count = this.items.length;
        this.footer.hidden = count === 0;
        if (count === 0) return;

        const project = this.projects.find(p => p.handle === this.currentHandle);
        this.footerContent.innerHTML = `
          <div class="briefcase-footer__info">
            <span class="briefcase-footer__count">${count} item${count !== 1 ? 's' : ''}${project ? ` in "${escapeHtml(project.name)}"` : ''}</span>
          </div>
        `;
      }

      // ---- Remove with animation ----

      async removeItem(itemId) {
        const li = this.container.querySelector(`[data-item-id="${itemId}"]`);
        if (li) {
          li.classList.add('briefcase-item--removing');
        }

        try {
          await briefcaseApi.removeItem(this.currentHandle, itemId);
          // Wait for animation to finish
          setTimeout(() => {
            this.items = this.items.filter(i => i.id !== itemId);
            this.renderItemsArea();
            this.renderFooter();
          }, 300);
          showBriefcaseToast(theme.briefcaseStrings.itemRemoved);
        } catch (err) {
          if (li) li.classList.remove('briefcase-item--removing');
          showBriefcaseToast('Failed to remove item', 'error');
          console.error('Briefcase: Failed to remove item', err);
        }
      }

      // ---- Duplicate a single item (same product, new blank Type Number) ----

      async duplicateItem(itemId) {
        const s = theme.briefcaseStrings;
        try {
          const res = await briefcaseApi.duplicateItem(this.currentHandle, itemId);
          BriefcaseCache.clear(); // itemCount changed

          // Keep the project's item-count badge in the selector dropdown in sync
          const project = this.projects.find(p => p.handle === this.currentHandle);
          if (project && res && typeof res.itemCount === 'number') {
            project.itemCount = res.itemCount;
            this.renderProjectSelector();
          }

          // Re-fetch so this.items includes the new copy (with its server-assigned id)
          await this.loadItems(this.currentHandle);

          // Auto-open the Type Number modal on the new row so the user can label it
          if (res && res.id) {
            const copy = this.items.find(i => i.id === res.id);
            if (copy) {
              this._labelTarget = copy;
              this.showInlineModal('label');
            }
          }

          showBriefcaseToast(s.itemDuplicated || 'Item duplicated');
        } catch (err) {
          console.error('Briefcase: Failed to duplicate item', err);
          showBriefcaseToast('Failed to duplicate item', 'error');
        }
      }
    }
  );
}

// --------------- Add-to-Briefcase Button ---------------

if (!customElements.get('briefcase-add-button')) {
  customElements.define(
    'briefcase-add-button',
    class BriefcaseAddButton extends HTMLElement {
      constructor() {
        super();
        this.prompt = null;
      }

      connectedCallback() {
        this.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick(e) {
        e.preventDefault();
        e.stopPropagation();

        if (!theme.customer) {
          window.location.href = theme.storefrontLoginUrl;
          return;
        }

        if (this.prompt && this.prompt.hasAttribute('open')) {
          this.closePrompt();
          return;
        }

        this.showPrompt();
      }

      async showPrompt() {
        document.querySelectorAll('.briefcase-inline-prompt[open]').forEach(p => p.removeAttribute('open'));

        let projects = [];
        try {
          const cached = BriefcaseCache.get();
          if (cached && cached.projects) {
            projects = cached.projects;
          } else {
            const data = await briefcaseApi.getProjects();
            projects = data.projects || [];
            BriefcaseCache.set({ projects });
          }
        } catch (err) {
          console.error('Briefcase: Failed to load projects', err);
          showBriefcaseToast('Could not load projects', 'error');
          return;
        }

        const s = theme.briefcaseStrings;

        if (!this.prompt) {
          this.prompt = document.createElement('div');
          this.prompt.className = 'briefcase-inline-prompt';
          // On product page: append to the container wrapper for full-width dropdown
          // In table: append to the custom element itself
          const container = this.closest('.briefcase-button-container') || this;
          container.style.position = 'relative';
          container.appendChild(this.prompt);
        }

        // In the configurator table the prompt lives inside .product-table-wrapper,
        // which is a scroll container in both axes (overflow-x:auto forces overflow-y
        // to auto). Opening downward on the bottom row would grow the wrapper's
        // internal scroll instead of overlaying past the table. Portal the prompt to
        // <body> — mirroring the datasheet dropdown — so it escapes that overflow.
        this._inTable = !!this.closest('.product-table');

        const hasProjects = projects.length > 0;
        this.prompt.innerHTML = `
          <p class="briefcase-inline-prompt__title">${hasProjects ? s.selectProject : s.newProject}</p>
          ${hasProjects ? `
            <select data-briefcase-prompt-select>
              ${projects.map(p =>
                `<option value="${p.handle}">${escapeHtml(p.name)}${p.itemCount ? ` (${p.itemCount})` : ''}</option>`
              ).join('')}
              <option value="__new__">+ ${s.newProject}</option>
            </select>
          ` : ''}
          <div class="briefcase-inline-prompt__new" ${hasProjects ? 'hidden' : ''}>
            <input type="text" placeholder="${s.projectNamePlaceholder}" data-briefcase-prompt-name>
          </div>
          <div class="briefcase-inline-prompt__actions">
            <button class="briefcase-prompt-btn" type="button" data-briefcase-prompt-add>${hasProjects ? s.addButton : s.createProject}</button>
          </div>
        `;

        if (hasProjects) {
          const select = this.prompt.querySelector('[data-briefcase-prompt-select]');
          const newSection = this.prompt.querySelector('.briefcase-inline-prompt__new');
          const addBtn = this.prompt.querySelector('[data-briefcase-prompt-add]');
          select.addEventListener('change', () => {
            const isNew = select.value === '__new__';
            newSection.hidden = !isNew;
            addBtn.textContent = isNew ? s.createProject : s.addButton;
            if (isNew) newSection.querySelector('input')?.focus();
          });
        }

        // Close any open datasheet dropdowns (without toggling overflow class)
        document.querySelectorAll('[data-datasheet-dropdown][aria-hidden="false"]').forEach(dd => {
          dd.setAttribute('aria-hidden', 'true');
          const container = dd.closest('[data-datasheet-container]');
          container?.querySelector('[data-datasheet-trigger]')?.setAttribute('aria-expanded', 'false');
        });

        if (this._inTable) {
          if (this.prompt.parentNode !== document.body) {
            document.body.appendChild(this.prompt);
          }
          this.prompt.classList.add('briefcase-inline-prompt--portaled');
          this.positionPortaledPrompt();
          // Idempotent: remove any prior handler before re-adding.
          if (this._repositionHandler) {
            window.removeEventListener('scroll', this._repositionHandler, { capture: true });
            window.removeEventListener('resize', this._repositionHandler);
          }
          this._repositionHandler = () => {
            // Self-heal: if [open] was stripped externally (e.g. the section
            // closes briefcase prompts when a datasheet dropdown opens), tear
            // down so we don't leak scroll listeners.
            if (!this.prompt || !this.prompt.hasAttribute('open')) {
              this.closePrompt();
              return;
            }
            this.positionPortaledPrompt();
          };
          window.addEventListener('scroll', this._repositionHandler, { capture: true, passive: true });
          window.addEventListener('resize', this._repositionHandler);
        }

        this.prompt.setAttribute('open', '');
        setTimeout(() => this.prompt.querySelector('input')?.focus(), 50);

        // Prevent clicks inside from closing
        this.prompt.onmousedown = (e) => e.stopPropagation();

        // Event delegation
        this.prompt.onclick = async (e) => {
          e.stopPropagation();
          const target = e.target.closest('[data-briefcase-prompt-add]');
          if (!target) return;

          target.classList.add('briefcase-prompt-btn--loading');
          const originalText = target.textContent;
          target.textContent = '...';

          try {
            const select = this.prompt.querySelector('[data-briefcase-prompt-select]');
            const isNewProject = !select || select.value === '__new__';

            if (isNewProject) {
              const input = this.prompt.querySelector('[data-briefcase-prompt-name]');
              const name = input?.value?.trim();
              if (!name) { input?.focus(); target.classList.remove('briefcase-prompt-btn--loading'); target.textContent = originalText; return; }
              const data = await briefcaseApi.createProject(name);
              // Optimistic: add new project to cache immediately
              const cached = BriefcaseCache.get() || { projects: [] };
              cached.projects.push({ id: data.id, handle: data.handle, name, itemCount: 0 });
              BriefcaseCache.set(cached);
              await this.addToProject(data.handle, name);
            } else {
              const projectName = select.options[select.selectedIndex]?.textContent || '';
              await this.addToProject(select.value, projectName);
            }
          } catch (err) {
            console.error('Briefcase: Failed', err);
            showBriefcaseToast('Action failed', 'error');
            target.classList.remove('briefcase-prompt-btn--loading');
            target.textContent = originalText;
          }
        };

        // Enter key on input
        this.prompt.querySelectorAll('input').forEach(input => {
          input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              const btn = this.prompt.querySelector('[data-briefcase-prompt-create], [data-briefcase-prompt-add]');
              btn?.click();
            }
            if (e.key === 'Escape') this.closePrompt();
          });
        });

        // Close on outside click
        setTimeout(() => {
          this._outsideClick = (e) => {
            if (this.prompt && this.prompt.contains(e.target)) return;
            if (this.contains(e.target)) return;
            const container = this.closest('.briefcase-button-container');
            if (container && container.contains(e.target)) return;
            this.closePrompt();
          };
          document.addEventListener('click', this._outsideClick);
        }, 10);
      }

      async addToProject(handle, projectName) {
        const product = {
          productId: this.dataset.productId,
          variantId: this.dataset.variantId || '',
          handle: this.dataset.productHandle,
          title: this.dataset.productTitle,
          sku: this.dataset.productSku || '',
          imageUrl: this.dataset.productImage || '',
          datasheetUrl: this.dataset.datasheetUrl || '',
          iesUrl: this.dataset.iesUrl || ''
        };

        // Duplicates are allowed: the same product can be added again (e.g. a
        // different Type Number per area). The Worker gives each row its own id.
        // Errors propagate to the caller (showPrompt), which shows a toast and
        // resets the button.
        await briefcaseApi.addItem(handle, product);
        showBriefcaseSuccessNotification({ product, projectName });
        BriefcaseCache.clear();
        theme.pubsub.publish(BRIEFCASE_UPDATE);
        this.closePrompt();
      }

      // Position a body-portaled prompt in document coords, anchored so its
      // top-right corner sits at the trigger's bottom-right (mirrors the
      // datasheet dropdown's positionDatasheetDropdown).
      positionPortaledPrompt() {
        if (!this.prompt) return;
        const rect = this.getBoundingClientRect();
        this.prompt.style.left = (rect.right + window.scrollX) + 'px';
        this.prompt.style.top = (rect.bottom + window.scrollY + 4) + 'px';
        this.prompt.style.transform = 'translateX(-100%)';
        // Clamp against the left viewport edge so it stays visible.
        const ddRect = this.prompt.getBoundingClientRect();
        if (ddRect.left < 8) {
          this.prompt.style.transform = `translateX(calc(-100% + ${8 - ddRect.left}px))`;
        }
      }

      closePrompt() {
        if (this.prompt) this.prompt.removeAttribute('open');
        if (this._outsideClick) {
          document.removeEventListener('click', this._outsideClick);
          this._outsideClick = null;
        }
        if (this._repositionHandler) {
          window.removeEventListener('scroll', this._repositionHandler, { capture: true });
          window.removeEventListener('resize', this._repositionHandler);
          this._repositionHandler = null;
        }
        // Unportal: move the prompt back into the button and clear inline styles
        // so the DOM stays consistent for future opens / virtual re-renders.
        if (this.prompt && this._inTable && this.prompt.parentNode === document.body) {
          this.prompt.classList.remove('briefcase-inline-prompt--portaled');
          this.prompt.style.top = '';
          this.prompt.style.left = '';
          this.prompt.style.transform = '';
          this.appendChild(this.prompt);
        }
      }
    }
  );
}

// --------------- Search Results Briefcase Intercept ---------------
// xCloud Search renders product cards client-side and bypasses Liquid,
// so the theme's `use_briefcase` flag cannot reach them. On the search
// page we swap any cart quick-add form for a <briefcase-add-button> after
// the app injects results, and intercept submit events as a fallback.

(function setupSearchBriefcaseIntercept() {
  function onSearchPage() {
    return (
      window.location.pathname.startsWith('/search') ||
      document.body?.classList.contains('template-search')
    );
  }
  if (!onSearchPage()) return;

  const addLabel = (window.theme?.briefcaseStrings?.addButton) || 'Add to Project Briefcase';
  let briefcaseIconUrl = '';
  function resolveIcon() {
    if (briefcaseIconUrl) return briefcaseIconUrl;
    briefcaseIconUrl = document.querySelector('.briefcase-drawer-button img')?.src || '';
    return briefcaseIconUrl;
  }

  function extractProductData(form) {
    const card = form.closest('.product-card');
    if (!card) return null;
    const variantId = form.querySelector('input[name="id"]')?.value || '';
    const productId = form.querySelector('input[name="product-id"]')?.value || '';
    if (!productId || !variantId) return null;
    const titleLink = card.querySelector('.product-card__title');
    const img = card.querySelector('.product-card__media img');
    const productUrl = titleLink?.getAttribute('href') || '';
    const handle = (productUrl.split('/products/')[1] || '').split(/[?#]/)[0];
    return {
      productId,
      variantId,
      handle,
      title: titleLink?.textContent.trim() || '',
      image: img?.currentSrc || img?.src || '',
      url: productUrl
    };
  }

  function buildBriefcaseButton(data) {
    const wrapper = document.createElement('briefcase-add-button');
    wrapper.className = 'briefcase-product-btn briefcase-button-container pointer-events-auto';
    wrapper.dataset.productId = data.productId;
    wrapper.dataset.variantId = data.variantId;
    wrapper.dataset.productHandle = data.handle;
    wrapper.dataset.productTitle = data.title;
    wrapper.dataset.productSku = '';
    wrapper.dataset.productImage = data.image;
    wrapper.dataset.datasheetUrl = data.url ? `${data.url}?view=datasheet` : '';

    const iconUrl = resolveIcon();
    const iconImg = iconUrl
      ? `<img class="button__icon briefcase-trigger__icon md:hidden" src="${iconUrl}" alt="" width="18" height="18" loading="lazy">`
      : '';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--primary briefcase-trigger md:opacity-0';
    btn.setAttribute('aria-label', addLabel);
    btn.innerHTML = `
      <span class="btn-fill" data-fill></span>
      <span class="button__text">
        ${iconImg}
        <span class="hidden md:block">${escapeHtml(addLabel)}</span>
      </span>
    `;
    wrapper.appendChild(btn);
    return wrapper;
  }

  function convertForm(form) {
    if (form.dataset.briefcaseConverted) return null;
    const data = extractProductData(form);
    if (!data) return null;
    form.dataset.briefcaseConverted = 'true';
    const wrapper = buildBriefcaseButton(data);
    form.replaceWith(wrapper);
    return wrapper;
  }

  function scan(root) {
    (root || document).querySelectorAll?.('.quick-add form[is="product-form"]')
      .forEach(convertForm);
  }

  // Pre-emptive DOM replacement
  scan(document);
  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('.quick-add form[is="product-form"]')) {
          convertForm(node);
        } else if (node.querySelectorAll) {
          scan(node);
        }
      }
    }
  });
  const start = () => observer.observe(document.body, { childList: true, subtree: true });
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });

  // Fallback: capture-phase submit interceptor. Runs before product-form's
  // own submit handler so we can block /cart/add and trigger briefcase.
  document.addEventListener('submit', (e) => {
    if (!onSearchPage()) return;
    const path = e.composedPath?.() || [e.target];
    const form = path.find((n) => n?.tagName === 'FORM' && n.getAttribute?.('is') === 'product-form');
    if (!form) return;
    const inQuickAdd = path.some((n) => n?.classList?.contains?.('quick-add'));
    if (!inQuickAdd) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const data = extractProductData(form);
    if (!data) return;
    const wrapper = convertForm(form) || buildBriefcaseButton(data);
    if (!wrapper.isConnected) form.parentNode?.appendChild(wrapper);
    // Defer to next tick so connectedCallback wires up the click handler.
    setTimeout(() => wrapper.click(), 0);
  }, true);

  // Same intercept on click, in case product-form intercepts at button click
  // rather than form submit.
  document.addEventListener('click', (e) => {
    if (!onSearchPage()) return;
    const path = e.composedPath?.() || [e.target];
    const btn = path.find((n) => n?.tagName === 'BUTTON' && n.type === 'submit');
    if (!btn) return;
    const form = path.find((n) => n?.tagName === 'FORM' && n.getAttribute?.('is') === 'product-form');
    if (!form) return;
    const inQuickAdd = path.some((n) => n?.classList?.contains?.('quick-add'));
    if (!inQuickAdd) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const data = extractProductData(form);
    if (!data) return;
    const wrapper = convertForm(form) || buildBriefcaseButton(data);
    if (!wrapper.isConnected) form.parentNode?.appendChild(wrapper);
    setTimeout(() => wrapper.click(), 0);
  }, true);
})();
